const agegroups_query = `
    query
    {
      ageGroups
      {
          ageGroupId
          uuid
          title
      }
    }
`;

const brands_query = `
    query
    {
      brands
      {
          brandId
          uuid
          title
      }
    }
`;

const categories_query = `
    query
    {
      categories
      {
          categoryId
          uuid
          title
          subcategories {
            subcategoryId
            uuid
            title
            category{
              categoryId
            }
          }
      }
    }
`;

const colors_query = `
    query
    {
      colors
      {
          colorId
          uuid
          title
      }
    }
`;

const conditions_query = `
    query
    {
      conditions
      {
          conditionId
          uuid
          title
      }
    }
`;

const countries_query = `
    query
    {
      manufacturerCountries
      {
          manufacturerCountryId
          name
          code
      }
    }
`;

const filterToys_mutate = `
    mutation filterToys($filters: ToyFiltersInput!,
                        $selectedCat: String,
                        $selectedSubCat: String,
                        $keyword: String) {
        filterToys(filters: $filters,
                 selectedCat: $selectedCat,
                 selectedSubCat: $selectedSubCat,
                 keyword: $keyword) {
          searchResults {
            ... on ToyType {
              toyId
              uuid
              isInCollection
              title
              description
              sellingPrice
              originalPrice
              publishedDate
              commentNo
              likeNo
              isLiked
              shareNo
              toyImages {
                toyImageId
                fileName
              }
              categoryId {
                title
              }
              subCategoryId {
                title
              }
              brandId {
                title
              }
              userId {
                username
                firstName
                lastName
                userUuid
                activationDate
                ratingNo
                ratingCount
                avatarFileName
                isLoggedInUserFollowing
              }
              toyLikes{
                toyLikeId
                userId{
                  username
                  avatarFileName
                  isLoggedInUserFollowing
                }
              }
              toyComments{
                uuid
                toyCommentId      
                content
                likeNo
                userId{
                  username
                  avatarFileName
                }
                isLiked
                createBy
                createDate
                updateBy
                updateDate
              }
            }
            ... on VideoType {
              videoId
              title
              content
            }
            ... on StoryType {
              storyId
              title
              content
            }
          }
      }
  }
`;

const materials_query = `
    query
    {
      materials
      {
          materialId
          uuid
          title
      }
    }
`;

const SearchToys_query = `
    query($searchKeyword: String!)
    {
      searchResults(searchKeyword: $searchKeyword)
      {
        __typename
            ... on ToyType {
              toyId
              uuid
              isInCollection
              title
              description
              sellingPrice
              originalPrice
              publishedDate
              commentNo
              likeNo
              isLiked
              shareNo
              toyImages {
                toyImageId
                fileName
              }
              categoryId {
                title
              }
              subCategoryId {
                title
              }
              brandId {
                title
              }
              userId {
                username
                firstName
                lastName
                userUuid
                activationDate
                ratingNo
                ratingCount
                avatarFileName
                isLoggedInUserFollowing
              }
              toyLikes{
                toyLikeId
                userId{
                  username
                  avatarFileName
                  isLoggedInUserFollowing
                }
              }
              toyComments{
                uuid
                toyCommentId      
                content
                likeNo
                userId{
                  username
                  avatarFileName
                }
                replies{
                  uuid
                  userId
                  {
                    username
                    avatarFileName
                    isLoggedInUserFollowing
                  }
                  content
                  toyCommentId{
                    toyCommentId
                  }
                  likeNo
                  isLiked
                  createBy
                  createDate
                  updateDate
                  updateBy
                }
                isLiked
                createBy
                createDate
                updateBy
                updateDate
              }
            }
            ... on VideoType {
              uuid
              title
              likeNo
              isLiked
              videoLikes{
                videoLikeId
                userId{
                  username
                  avatarFileName
                  isLoggedInUserFollowing
                }
              }
            }
            ... on StoryType {
              uuid
              title
              likeNo
              isLiked
              storyLikes{
                storyLikeId
                userId{
                  username
                  avatarFileName
                  isLoggedInUserFollowing
                }
              }
            }
      }
    }
`;

const subcolors_query = `
    query
    {
      subColors
      {
          subColorId
          uuid
          title
      }
    }
`;

const warnings_query = `
    query
    {
      warnings
      {
          warningId
          uuid
          title
      }
    }
`;

module.exports = {
  AGE_GROUP_QUERY: agegroups_query,
  BRANDS_QUERY: brands_query,
  CATEGORY_QUERY: categories_query,
  COLORS_QUERY: colors_query,
  CONDITION_QUERY: conditions_query,
  COUNTRIES_QUERY: countries_query,
  FILTER_TOYS: filterToys_mutate,
  MATERIALS_QUERY: materials_query,
  SEARCH_TOYS: SearchToys_query,
  SUBCOLORS_QUERY: subcolors_query,
  WARNING_QUERY: warnings_query
};
